// 把 (x, y) 轉成 CSS left/top/transform，預設左上錨點
export function anchorStyle(px, { x, y, anchor = 'tl' }) {
  const map = {
    tl: '0,0',
    t : '-50%,0',
    tr: '-100%,0',
    l : '0,-50%',
    c : '-50%,-50%',
    r : '-100%,-50%',
    bl: '0,-100%',
    b : '-50%,-100%',
    br: '-100%,-100%',
  };
  const tr = map[anchor] ?? '0,0';
  return {
    position: 'absolute',
    left: px(x),
    top:  px(y),
    transform: `translate(${tr})`,
  };
}
